import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Link,
  Modal,
  Pagination,
  Stack,
} from '@mui/material';
import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import SearchIcon from '@mui/icons-material/Search';
import Swal from 'sweetalert2';
import secureLocalStorage from 'react-secure-storage';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import commaNumber from 'comma-number';
import { format } from 'date-fns';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReConfirm from '../../images/undraw/undraw_confirmation_re_b6q5.svg';
import { Calendar } from 'react-date-range';
import { createMRTColumnHelper } from 'material-react-table';
import CummonTable from '../../Common/CummonTable';
import FetchLoading from '../../Loading/FetchLoading';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none !important',
  boxShadow: 24,
  p: { xs: 2, md: 4 },
  borderRadius: '10px',
  outline: 'none !important',
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentManagement = () => {
  const columnHelper = createMRTColumnHelper();
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo.token;
  const adminName = `${adminInfo?.firstname}${' '}${adminInfo?.lastname}`;

  const [isLoading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [allPaymentData, setAllPaymentData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  //  pagination handle
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  let size = 20;
  // Handle a page change.
  const handlePageChange = (event, value) => {
    setPage(value);
    setPaymentData(allPaymentData?.slice((value - 1) * size, value * size));
  };

  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const viewImage = (imageUrl) => {
    setSelectedImage(null);
    setIsModalOpen(true);
    setLoading(true); // Set loading state to true

    fetch(imageUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.blob();
      })
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob);
        setSelectedImage(objectURL); // Set selectedImage to the object URL once image is loaded
        setLoading(false); // Set loading state to false after image is loaded
      })
      .catch((error) => {
        console.error('Error fetching image:', error);
        setLoading(false); // Set loading state to false in case of error
        // Handle error state if needed
      });
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const columns = [
    columnHelper.accessor('agentId', {
      header: 'Agent Id',
      Cell: ({ row }) => (
        <button
          style={{
            background: 'gray',
            borderRadius: '5px',
            padding: '2px 10px',
            width: '120px',
            cursor: 'pointer',
            border: 'none',
            color: 'var(--white)',
          }}
        >
          {row.original.agentId}
        </button>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),

    columnHelper.accessor('paymentway', {
      header: 'Type',
      Cell: ({ row }) => `${row.original.paymentway || 'N/A'}`,
      size: '10px',
    }),

    columnHelper.accessor('sender', {
      header: 'Sender Acc',
      Cell: ({ row }) => `${row.original.sender || 'N/A'}`,
      size: '10px',
    }),
    columnHelper.accessor('receiver', {
      header: 'Receiver',
      Cell: ({ row }) => `${row.original.receiver || 'N/A'}`,
      size: '10px',
    }),

    columnHelper.accessor('amount', {
      header: 'Amount',
      Cell: ({ row }) => `${commaNumber(row.original.amount) + ' AED' || '0'}`,
    }),
    columnHelper.accessor('action', {
      header: 'Action',
      Cell: ({ row }) => (
        <>
          {row.original?.status === 'pending' ? (
            <Box sx={{ display: 'flex' }}>
              <IconButton
                sx={{ color: '#0E8749' }}
                onClick={() => handleApprove(row.original, 'approved')}
              >
                <CheckCircleIcon sx={{ fontSize: '20px' }} />
              </IconButton>
              <IconButton
                sx={{ color: 'var(--remove-color)' }}
                onClick={() => handleClickOpen(row.original)}
              >
                <CancelIcon sx={{ fontSize: '20px' }} />
              </IconButton>
            </Box>
          ) : (
            <span
              style={{
                border: 'none',
                borderRadius: '5px',
                width: '100%',
              }}
              className={`${row.original?.status
                ?.toLowerCase()
                ?.split(' ')
                ?.join('-')}-btn`}
            >
              {row.original?.status}
            </span>
          )}
        </>
      ),
    }),
    columnHelper.accessor('created_at', {
      header: 'Date',
      size: 20,
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
    columnHelper.accessor('attachment', {
      header: 'View',
      size: 20,
      Cell: ({ row }) => (
        <Box>
          {row.original?.attachment?.split('.').pop().toLowerCase() ===
          'pdf' ? (
            <a
              href={row.original?.attachment}
              target="_blank"
              rel="noreferrer"
              style={{ color: 'black' }}
            >
              <Box sx={{ fontSize: 14 }}>View</Box>
            </a>
          ) : (
            <Box
              sx={{
                cursor: 'pointer',
                bgcolor: 'var(--bgcolor)',
                borderRadius: 10,
                color: 'var(--primary)',
              }}
              onClick={() => viewImage(row.original?.attachment)}
            >
              View
            </Box>
          )}
        </Box>
      ),
    }),

    columnHelper.accessor('ref', {
      header: 'Reference',
      Cell: ({ row }) => `${row.original.ref || 'N/A'}`,
      size: '10px',
    }),
    columnHelper.accessor('remarks', {
      header: 'Remarks',
      size: 20,
      Cell: ({ row }) =>
        `${row.original?.remarks === '' ? 'N/A' : row.original?.remarks}`,
    }),
  ];

  useEffect(() => {
    const fetchQueuesData = () => {
      setIsloading(true);

      fetch(`https://api-b2b.businesssolutions.ae/admin/deposit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setPaymentData(data);
          setAllPaymentData(data);
        })
        .catch((error) => console.error('Error fetching data:', error))
        .finally(() => setIsloading(false));
    };

    fetchQueuesData();
  }, [refetch]);

  // modal
  const [open, setOpen] = React.useState(false);

  const [rejectValue, setRejectValue] = useState('');
  const [reason, setReason] = useState('');

  const handleClickOpen = (depositvalue) => {
    setOpen(true);
    setRejectValue(depositvalue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // payment approved function
  const handleApprove = (depValue, status) => {
    setOpen(false);
    let body = JSON.stringify({
      amount: depValue.amount,
      sender: depValue.sender,
      receiver: depValue.receiver,
      paymentway: depValue.paymentway,
      ref: depValue.ref,
      status: status,
      remarks: depValue.reason,
    });

    Swal.fire({
      imageUrl: ReConfirm,
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
      title: 'Are you sure?',
      text: 'You want to approve this deposit?',
      showCancelButton: true,
      confirmButtonColor: 'var(--secondary-color)',
      confirmButtonText: 'Approve👍',
      cancelButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancel',
    }).then((willDelete) => {
      if (willDelete.isConfirmed) {
        setLoading(true);
        let url = `https://api-b2b.businesssolutions.ae/admin/deposit/status/${depValue?.uid}`;

        fetch(url, {
          method: 'PATCH',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include the token in the header
          },
          body: body,
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text:
                status === 'approved'
                  ? 'Payment Approved Successfully'
                  : 'Payment Rejected',
              confirmButtonText: 'OK',
            }).then(() => {
              setRefetch(!refetch);
            });
          })
          .catch((error) => {
            console.error('Error approving payment:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to approve payment. Please try again.',
              confirmButtonText: 'OK',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  return (
    <Box>
      <AdminHeader />
      <Box px={2}>
        <Typography
          variant="span"
          sx={{
            fontWeight: 400,
            fontSize: '24px',
            color: '#222222',
            pb: 1,
          }}
        >
          Agent Deposits
        </Typography>
        <Box>
          {!isLoading ? (
            <CummonTable data={paymentData} columns={columns} pageSize={15} />
          ) : (
            <FetchLoading />
          )}
        </Box>
        <Box>
          <form>
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{'Rejection Reason'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  <textarea
                    required
                    type="text"
                    rows="4"
                    placeholder="Enter Reason..."
                    style={{
                      width: '300px',
                      outline: 'none',
                      padding: '6px 5px',
                      border: '1px solid var(--flyhub)',
                      borderRadius: '3px',
                    }}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </DialogContentText>
                <Box pt={2}>
                  <Stack direction="row" justifyContent="space-between">
                    <Button
                      sx={{
                        color: '#fff',
                        px: 3,
                        py: 0.3,
                        bgcolor: 'red',
                        '&:hover': {
                          backgroundColor: 'green',
                        },
                      }}
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                    <Button
                      type="submit"
                      sx={{
                        color: '#fff',
                        px: 3,
                        py: 0.3,
                        bgcolor: 'green',
                        '&:hover': {
                          backgroundColor: 'green',
                        },
                      }}
                      onClick={() => handleApprove(rejectValue, 'rejected')}
                    >
                      Submit
                    </Button>
                  </Stack>
                </Box>
              </DialogContent>
            </Dialog>
          </form>
        </Box>
      </Box>
      <Modal open={isModalOpen} onClose={closeModal}>
        <Box sx={{ ...style, width: 'auto', height: 'auto' }}>
          {loading ? (
            'processing your request please wait..'
          ) : selectedImage === null ? (
            <>Attachment is not found !</>
          ) : (
            <Box
              sx={{
                img: {
                  maxWidth: { xs: '80vw', sm: '50vw', md: '40vw' },
                },
              }}
            >
              <img
                src={selectedImage}
                alt="Modal Image"
                // style={{ maxHeight: '40vh' }}
              />
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default PaymentManagement;
